// @ts-strict-ignore
import { TAccessory, TAccessoryGroup } from '@/shared/types/product-types'

export const formatData = (arr: TAccessoryGroup[]): TAccessory[] => {
	const result = []
	let i = 0
	while (result.length < 3 && i < 10) {
		arr.forEach(item => result.push({ ...item.ACCESSORIES[i], SECTION_ID: item.SECTION_ID }))
		i++
	}
	return result.slice(0, 3).filter(item => item !== undefined && item.KOD !== undefined)
}
